/**
 * Phase 3: アクション選択フェーズ（Puerto Rico 専用）
 *
 * Puerto Rico では2種類のアクション（ENGINEER, LOCOMOTIVE）から
 * 任意で1つを選択し、$5を支払う。選択しない（スキップ）ことも可能。
 *
 * @see docs/specifications/logic/puerto_rico/phase_03_select_actions_override.md
 */

import type { PhaseConfig } from 'boardgame.io';
import { debug } from '../../utils/debug';
import type { PuertoRicoGameState } from '../../types';
import { selectActionPuertoRico, skipAction } from '../moves/selectActionsPuertoRico';
import { undoToTurnStart } from '../moves/undoToTurnStart';

export const selectActionsPuertoRicoPhase: PhaseConfig<PuertoRicoGameState> = {
  moves: {
    selectAction: selectActionPuertoRico,
    skipAction: skipAction,
    undoToTurnStart: undoToTurnStart as any,
  },

  turn: {
    // ソロプレイなので各フェーズで1ターンのみ
    minMoves: 1,
    maxMoves: 1
  },

  // Phase開始時の処理
  onBegin: ({ G }: { G: PuertoRicoGameState }) => {
    // アクション選択完了フラグをリセット
    G.isActionSelectionComplete = false;

    // プレイヤーの選択アクションをリセット
    const playerId = '0';
    const player = G.players[playerId];
    if (player) {
      player.selectedAction = null;
    }

    debug.log(`[selectActionsPuertoRicoPhase] Phase started (Turn ${G.actualTurn})`);
  },

  // Phase終了条件: アクション選択完了（選択 or スキップ）、または Undo 強制遷移
  endIf: ({ G }: { G: PuertoRicoGameState }) => {
    // Undo 強制遷移フラグが立っている場合は即座に終了
    if (G.forcePhaseToIssueShares) {
      debug.log(`[selectActionsPuertoRicoPhase] Force transition to issueShares (Undo)`);
      return true;
    }
    return G.isActionSelectionComplete === true;
  },

  // Phase 4 へ遷移、または Undo 時は issueShares へ
  next: ({ G }: { G: PuertoRicoGameState }) => {
    if (G.forcePhaseToIssueShares) {
      return 'issueShares';
    }
    return 'buildTrack';
  }
};
